<template>

  <body class="landingBody">
    <div class="mobileNavTop">
      <a @click="mixNav" class="iconBarsMobile"><i class="fas fa-bars"></i></a>
      <div class="logoContainerMobile">
        <a href="/index"><img src="../assets/images/logo-white.svg" alt="" /></a>
      </div>
      <a href="#" class="iconCartMobile openSidebar"><img src="../assets/images/icon-cart.svg" alt="" /></a>
    </div>
    <div v-bind:class="{ burgerMenuContainer: true, active: showNav }">
      <div @click="mixNav()" class="burgerHeader">
        <a href="#" class="closeMenu"><i class="far fa-times"></i></a>
      </div>
      <div class="burgerBody">
        <nav>
          <ul class="topMenu">
            <li class="">
              <router-link to="/index" target="_self">
                Home
              </router-link>
            </li>
            <li class="">
              <router-link to="/shop" target="_self">
                Shop
              </router-link>
            </li>
            <li class="">
              <router-link to="user/account" target="_self">
                Account
              </router-link>
            </li>
            <li class="active">
              <router-link to="/how-it-works" target="_self">
                How It Works
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <div class="burgerBot">
        <p>supremeaccess | Legal | Disclousure</p>
      </div>
    </div>
    <div class="landingHeight">
      <header class="landHeader">
        <div class="landHeaderSub">
          <div class="logoContainer">
            <a href="/index"><img src="../assets/images/logo-white.svg" alt="" /></a>
          </div>
          <nav class="landHeadNav">
            <li>
              <a href="#" class="openSidebar"><img src="../assets/images/icon-cart.svg" alt="" /></a>
            </li>
          </nav>
        </div>
      </header>
      <section class="homeBot">
        <div class="homeBotBod">
          <div class="desktop flexMenu" style="margin-bottom: 120px;">
          <li class="">
            <router-link to="/index">Home</router-link>
          </li>
          <li>
            <router-link to="/shop">Shop</router-link>
          </li>
          <li v-if="loggedIn">
            <router-link to="/user/account">Account</router-link>
          </li>
          <li v-if="!loggedIn">
            <router-link to="/login">Login</router-link>
          </li>
          <li class="active">
            <router-link to="/how-it-works">How It Works</router-link>
          </li>
        </div>
          <div class="pageTitle">
            <h1>How It Works</h1>
          </div>
        </div>
      </section>
    </div>
    <section class="firstSect">
      <div class="container">
        <div class="dualSect">
          <div class="dualLeft">
            <h4 class="marginLeft40">01</h4>
            <img src="../assets/images/hoodie.png" alt="" />
            <img class="mobileVersionLeft" src="../assets/images/sa-shirt@3x.png" alt="" />
          </div>
          <div class="dualRight">
            <h4>Auto Checkout</h4>
            <p>
              The information provided in the first form will be the information
              that will be used to checkout with on Supreme on the release
              date/time. The second form through Stripe is paying the service
              fee for the item(s).
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="secondSect">
      <div class="container">
        <div class="dualSectTopBot">
          <div class="dualTop">
            <h4>02</h4>
          </div>
          <div class="triBot">
            <div class="triContIndi">
              <h4>Auto Checkout</h4>
              <p>
                The information provided in the first form will be the
                information that will be used to checkout with on Supreme on the
                release date/time. The second form through Stripe is paying the
                service fee for the item(s).
              </p>
            </div>
            <div class="triContIndi">
              <h4>Auto System</h4>
              <p>
                Our system takes your payment info / shipping (securely) and
                both carts and submits the order in the size/color/quantity
                instantly for you.
              </p>
            </div>
            <div class="triContIndi">
              <h4>Confirmation</h4>
              <p>
                You will receive a forwarded confirmation email from us from
                supreme if successful, and or charge on the card provided. Make
                sure to check both as emails will not be sent out instantly.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="firstSect">
      <div class="container">
        <div class="dualSect">
          <div class="dualLeft dualLeftSectThree">
            <h4 class="marginRight40">03</h4>
            <img src="../assets/images/beanie.png" alt="" />
            <img class="mobileVersionRight" src="../assets/images/sa-beanie@3x.png" alt="" />
          </div>
          <div class="dualRight">
            <h4>Complete</h4>
            <p>
              That’s it! With the information provided you can sleep in and
              still secure your item! Always make sure to double check info on
              order in the “My account” section of our site. If anything is
              incorrect please contact us immediately
            </p>
            <p style="margin-top:20px;">
              (Email: support@supremeaccess.io) to submit revisions and fix any
              errors before release
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="footSect">
      <div class="container">
        <div class="footSectCont">
          <div class="footSectInline">
            <i class="far fa-comment-alt-lines"></i>
            <p>
              Our prices do not include the retail cost of the item from supreme
              you are wanting to purchase. Supreme does not ship to PO boxes –
              If you provide a PO box and your order fails we do not offer
              refunds. You are 100% guaranteed the item or you will receive a
              full refund from us within 72 hours (May vary depending on
              restocks).
            </p>
          </div>
        </div>
      </div>
    </section>
  </body>
</template>
<script>
  export default {
    created(){
      this._vm.$intercom.boot(intercomOpts)

    },
    data() {
      return {
        showNav: false
      }
    },
    methods: {
      mixNav() {
        this.showNav = !this.showNav
      }
    },
    computed: {
      loggedIn() {
        let loggedIn = localStorage.getItem('user')
        return loggedIn
      }
    }
  }
</script>
